export const commercialObjectTypes = [
  {
    name: 'Офис',
    genitiveName: 'Офиса',
    key: 'office',
  },
  {
    name: 'Здание',
    genitiveName: 'Здания',
    key: 'building',
  },
  {
    name: 'Торговая площадь',
    genitiveName: 'Торговой площади',
    key: 'shoppingArea',
  },
  {
    name: 'Помещение свободного назначения',
    genitiveName: 'Помещения свободного назначения',
    key: 'freeAppointmentObject',
  },
  {
    name: 'Производство',
    genitiveName: 'Производства',
    key: 'industry',
  },
  {
    name: 'Склад',
    genitiveName: 'Склада',
    key: 'warehouse',
  },
  {
    name: 'Гараж',
    genitiveName: 'Гаража',
    key: 'garage',
  },
  {
    name: 'Готовый бизнес',
    genitiveName: 'Готового бизнеса',
    key: 'business',
  },
  {
    name: 'Коммерческая земля',
    genitiveName: 'Коммерческой земли',
    key: 'commercialLand',
  },
];

const typesWithoutBusiness = commercialObjectTypes.filter(type => type.key !== 'business');

const typeCoworking = {
  name: 'Коворкинг',
  genitiveName: 'Коворкинга',
  key: 'coworking',
};

export const commercialRentTypes = [...[typesWithoutBusiness[0], typeCoworking], ...typesWithoutBusiness.slice(1)];

// убрали возможность создавать новые объявки аренда гб, но должны оставить возможность редактировать подобные объявки
export const commercialRentTypesForEditing = [
  ...[commercialObjectTypes[0], typeCoworking],
  ...commercialObjectTypes.slice(1),
];

export const coworkingSubTypes = [
  {
    name: 'Отдельный офис',
    genitiveName: 'Отдельного офиса',
    key: 'office',
  },
  {
    name: 'Закреплённое рабочее место',
    genitiveName: 'Закреплённого рабочего места',
    key: 'fixedWorkplace',
  },
  {
    name: 'Незакреплённое рабочее место',
    genitiveName: 'Незакреплённого рабочего места',
    key: 'flexibleWorkplace',
  },
];

export const coworkingAnalyticSubTypes = {
  office: 'flexible_office',
  fixedWorkplace: 'fixed_workplace',
  flexibleWorkplace: 'unfixed_workplace',
  conferenceHall: 'conference_hall',
  meetingRoom: 'meeting_room',
};
